import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon12amTo3am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97531 12.8295C10.5986 12.8295 12.7253 10.7029 12.7253 8.07953C12.7253 5.45619 10.5986 3.32956 7.97531 3.32956C5.35198 3.32956 3.22534 5.45619 3.22534 8.07953C3.22534 10.7029 5.35198 12.8295 7.97531 12.8295ZM7.97531 14.0795C11.289 14.0795 13.9753 11.3932 13.9753 8.07953C13.9753 4.76584 11.289 2.07956 7.97531 2.07956C4.66162 2.07956 1.97534 4.76584 1.97534 8.07953C1.97534 11.3932 4.66162 14.0795 7.97531 14.0795Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon12amTo3am;
